<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <!-- 제목 -->
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              width="140px"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              ref="titleTxtFld"
              v-model.trim="approvalData.approvalTitle"
              max-length="30"
              default
              style="width: 100%"
              :clearable="true"
              :readonly="isTitleReadonly"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_APRV_USR')"
              width="140px"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div
              class="width100"
              style="flex-direction:row"
            >
              <cmp-user-select
                ref="user"
                class="mrB05 width100"
                @selected="onSelectedUser"
              />
              <cmp-approval-list-manager
                ref="approvalManager"
                :pageId="contextPageId"
                :emailFieldName="'approvalUserEmail'"
                :approverDispFormat="approverDispFormat"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_FILE')"
              width="140px"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <cmp-file-attacher
              ref="fileAttacher"
              :pageId="contextPageId"
              :showDDRegion="false"
              :attachGroupId="approvalAttachGroupId"
              :attachDocumentId="approvalData.approvalAttachDocumentId"
              class="width100"
              :deletableOld="isTransFileModify"
              :disabled="isfileDisabled"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CNTN')"
              width="140px"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-web-editor
              ref="approvalWebEditor"
              class="width100"
              :maxCharCount="maxContentsSize"
            />
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div
        v-if="isThisWindowPopup"
        class="comm_btn_wrap"
      >
        <!-- 보류 -->
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickholdon"
        >
          {{ $t("MSG_TIT_HOLDON") }}
        </sui-button>
        <!-- 결재상신 -->
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickProposal"
        >
          {{ $t("MSG_BTN_APRV_SUBM") }}
        </sui-button>
      </div>
    </sui-page-contents>

    <!-- Page Footer -->
    <sui-page-footer
      v-if="isThisLayerPopup"
    >
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ $t("MSG_BTN_CANCEL") }}
        </sui-button>
        <!-- 보류 -->
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickholdon"
        >
          {{ $t("MSG_TIT_HOLDON") }}
        </sui-button>
        <!-- 결재상신 -->
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onClickProposal"
        >
          {{ $t("MSG_BTN_APRV_SUBM") }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

// 결재라인 을 DB 에 insert 하기 위해 꼭 필요한 필드 정보들 정의
// validation check
const USER_COLUMNS_FOR_SAVE = [
  { columnName: 'approvalDepartmentEnglishName', required: false },
  { columnName: 'approvalDepartmentName', required: false },
  { columnName: 'approvalDepartmentId', required: false },
  { columnName: 'approvalOrder', required: true }, // 결재순서
  { columnName: 'approvalParallelOrder', required: true }, // 결재병렬순서
  { columnName: 'approvalUserEmail', required: true },
  { columnName: 'approvalUserGlobalName', required: true },
  { columnName: 'approvalUserId', required: true },
  { columnName: 'approvalUserName', required: true }, // 결재사용자명
  { columnName: 'rightApprovalTypeCode', required: true }, // 결재권유형코드
  { columnName: 'rightApprovalTypeStateCode', required: true }, // 결재권유형상태코드
  { columnName: 'userDisplayLanguageId', required: true },
];

const USER_PROPS_FOR_APPEND = [
  'approvalDepartmentDispName',
  'approvalDepartmentEnglishName',
  'approvalDepartmentName',
  'approvalDepartmentId',
  // 'approvalUserCareerLevelCode',
  // 'approvalUserCareerLevelDispName',
  // 'approvalUserCareerLevelEnglishName',
  // 'approvalUserCareerLevelName',
  'approvalUserDispName',
  'approvalUserEmail',
  'approvalUserGlobalName',
  'approvalUserId',
  'approvalUserName',
];

export default {
  name: 'PGE_CML_00007', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      required: false,
      default() {
        return {
          approvalAttachGroupId: '',
          approvalModuleCode: '',
          approvalData: {
            approvalUid: '',
          },
        };
      },
    },
  },
  data() {
    return {
      approvalAttachGroupId: utils.isEmpty(this.pageInitialData.approvalAttachGroupId) ? 'ATG_CML_APRV_COMMON' : this.pageInitialData.approvalAttachGroupId,
      approvalModuleCode: utils.isEmpty(this.pageInitialData.approvalModuleCode) ? 'CM' : this.pageInitialData.approvalModuleCode,
      approvalData: {
        approvalAttachDocumentId: '', // 결재첨부문서ID
        approvalCompletionDTM: '', // 결재완료일시
        approvalCompletionUserId: '', // 결재완료사용자ID
        approvalContent: '', // 결재내용
        approvalDraftDepartmentId: '', // 결재작성부서ID
        approvalDraftDTM: '', // 결재작성일시
        approvalDraftUserId: '', // 결재작성사용자ID
        approvalOpinionContent: '', // 상신의견
        approvalProgressStateCode: '', // 결재진행상태코드
        approvalTitle: '', // 결재제목
        approvalUid: '', // 결재UID
        presentApprovalOrder: '', // 현재결재순서
        presentApprovalParallelOrder: '', // 현재결재병렬순서
        presentApprovalUserId: '', // 현재결재사용자ID
        presentRightApprovalTypeCode: '', // 현재결재권유형코드

        approvalUserList: [],
        attachFileList: [],
      },
      approverDispFormat: '${approvalUserDispName}/${approvalUserCareerLevelDispName}/${approvalDepartmentDispName}/${approvalUserEmail}', // eslint-disable-line
      maxContentsSize: utils.getConfigurationValue('CFG_CMZ_APRV_CONT_LIMIT_SIZE'),
      isThisLayerPopup: this.closePagePopup !== null,
      isThisWindowPopup: this.closePagePopup === null,

      isfileDisabled: false,
      isTransFileModify: true,
      isTitleReadonly: false,
    };
  },
  computed: {
    // 계산된 속성, property로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    // utils.getParameter(this, 'approvalUid');
    if (this.isThisWindowPopup || utils.isEmpty(this.pageInitialData.approvalData.approvalUid)) {
      // 로그인자를 기안자로 설정
      this.setLoginUserToDrafter();
    } else {
      // approvalUid 로 기존 데이터 조회
      this.getApprovalByApprovalUid();
    }
  },
  beforeUpdate() {
    // data 변경전 DOM 정보가 필요한 경우
  },
  updated() {
    // data 변경후 DOM 정보가 필요한 경우
  },
  beforeDestroy() {
    // 이벤트 핸들러 및 사용한 서드 파티 라이브러리 자원 반환
  },
  destroyed() {
    // 남아 있는 자원 반환
  },

  methods: {
    /**
     * 결재선 추가
     */
    async appendApprover(userInfoObj) {
      const userInfo = utils.clone(userInfoObj);
      userInfo.approvalDepartmentDispName = this.getDisplayText(userInfoObj.dsplLngId, userInfoObj.departmentName, userInfoObj.departmentEnglishName);
      userInfo.approvalDepartmentEnglishName = userInfoObj.departmentEnglishName;
      userInfo.approvalDepartmentId = userInfoObj.departmentId;
      userInfo.approvalDepartmentName = userInfoObj.departmentName;
      userInfo.approvalUserCareerLevelCode = userInfoObj.careerLevelCode;
      userInfo.approvalUserCareerLevelDispName = this.getDisplayText(userInfoObj.dsplLngId, userInfoObj.careerLevelName, userInfoObj.careerLevelEnName);
      userInfo.approvalUserCareerLevelEnglishName = userInfoObj.careerLevelEnName;
      userInfo.approvalUserCareerLevelName = userInfoObj.careerLevelName;
      userInfo.approvalUserDispName = this.getDisplayText(userInfoObj.dsplLngId, userInfoObj.userName, userInfoObj.userGlobalName);
      userInfo.approvalUserEmail = userInfoObj.email;
      userInfo.approvalUserGlobalName = userInfoObj.userGlobalName;
      userInfo.approvalUserId = userInfoObj.userId;
      userInfo.approvalUserName = userInfoObj.userName;
      userInfo.userDisplayLanguageId = userInfoObj.dsplLngId;


      const result = await this.validateUserForAppend(userInfo);
      if (result === true) {
        this.$refs.approvalManager.addApprover(userInfo);
      } else {
        // this.closePagePopup();
        console.log(userInfo);
      }
    },
    /**
     * 보류함에 저장하시겠습니까?
     */
    confirmHoldon() {
      return new Promise(resolve => {
        // '보류함에 저장하시겠습니까?
        utils.messageBox('confirm', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_SAV_HOLDON'), () => {
          resolve(true);
        }, () => {
          resolve(false);
        });
      });
    },
    /**
     * confirm proposal
     */
    confirmProposal() {
      return new Promise(resolve => {
        // '상신 저장하시겠습니까?
        utils.messageBox('confirm', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_SUBM'), () => {
          resolve(true);
        }, () => {
          resolve(false);
        });
      });
    },
    /**
     * doHoldon
     * 상신보류(임시저장)
     */
    async doHoldon() {
      // validate approval title
      let isValid = await this.validateApprovalTitle();
      if (!isValid) return false;

      // validate approval user columns in approval line for save
      const approvalLineList = this.$refs.approvalManager.getApprovalPathList();
      for (let i = 0; i < approvalLineList.length; i += 1) {
        const approvalUser = approvalLineList[i];
        // '결재사용자상세' 테이블의 '결재권유형상태코드' 값 추가
        utils.set(approvalUser, 'rightApprovalTypeStateCode', `${approvalUser.rightApprovalTypeCode}0`);
        isValid = await this.validateUserForSave(approvalUser);
        if (!isValid) break;
      }
      if (!isValid) return false;

      // validate attach files
      isValid = await this.validateAttachFiles();
      if (!isValid) return false;

      isValid = await this.confirmHoldon();
      if (!isValid) return false;

      // 결재 데이터
      const dataParams = {};
      // 상신 내용
      this.approvalData.approvalContent = this.$refs.approvalWebEditor.getHtml();
      utils.assign(dataParams, { data: this.approvalData });
      // User 데이터 준비
      utils.assign(dataParams.data, { approvalUserList: approvalLineList });
      // 첨부파일 데이터 준비
      const attachFileList = this.$refs.fileAttacher.getAttachFileListInfo();
      if (attachFileList.length > 0) {
        utils.assign(dataParams.data, { attachFileList });
        utils.set(dataParams.data, 'approvalModuleCode', this.approvalModuleCode);
        utils.set(dataParams.data, 'approvalAttachGroupId', this.approvalAttachGroupId);
      }

      http.request(this.contextPageId, 'DTS_CML_00002', dataParams).then(() => {
        // "저장 되었습니다."
        utils.messageBox('success', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_SAVE_DATA'), () => {
          if (this.isThisWindowPopup) {
            // TODO: 
            window.CLOSE_SILIENTLY = true;
            window.TARGET_PAGEID = 'PGE_CML_00002';
            window.close();
          } else {
            this.closePagePopup(true);
          }
        });
      });
      return true;
    },
    /**
     * doProposal
     * 결재상신
     */
    async doProposal() {
      // validate approval title
      let isValid = await this.validateApprovalTitle();
      if (!isValid) return false;

      // validate approval user columns in approval line for save
      const approvalLineList = this.$refs.approvalManager.getApprovalPathList();
      for (let i = 0; i < approvalLineList.length; i += 1) {
        const approvalUser = approvalLineList[i];
        // '결재사용자상세' 테이블의 '결재권유형상태코드' 값 추가
        utils.set(approvalUser, 'rightApprovalTypeStateCode', `${approvalUser.rightApprovalTypeCode}0`);
        isValid = await this.validateUserForSave(approvalUser);
        if (!isValid) break;
      }
      if (!isValid) return false;

      if (utils.findIndex(approvalLineList, { rightApprovalTypeCode: 1 }) === -1
      && utils.findIndex(approvalLineList, { rightApprovalTypeCode: '1' }) === -1
      && utils.findIndex(approvalLineList, { rightApprovalTypeCode: 2 }) === -1
      && utils.findIndex(approvalLineList, { rightApprovalTypeCode: '2' }) === -1
      && utils.findIndex(approvalLineList, { rightApprovalTypeCode: 4 }) === -1
      && utils.findIndex(approvalLineList, { rightApprovalTypeCode: '4' }) === -1
      && utils.findIndex(approvalLineList, { rightApprovalTypeCode: 7 }) === -1
      && utils.findIndex(approvalLineList, { rightApprovalTypeCode: '7' }) === -1) {
        utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), this.$t('MSG_ALT_CHK_APRVR'));
        return false;
      }
      // validate approval contents
      isValid = await this.validateApprovalContents();
      if (!isValid) return false;

      // validate attach files
      isValid = await this.validateAttachFiles();
      if (!isValid) return false;

      // 상신의견 팝업 오픈
      // proposal opinion input popup open
      const opinionObj = await this.openApprovalOpinionPopup();
      if (!opinionObj || opinionObj.goProposal !== true) {
        return false;
      }
      this.approvalData.approvalOpinionContent = opinionObj.approvalOpinionContent;

      isValid = await this.confirmProposal();
      if (!isValid) return false;

      // 결재 데이터
      const dataParams = {};

      // 상신 내용
      this.approvalData.approvalContent = this.$refs.approvalWebEditor.getHtml();
      utils.assign(dataParams, { data: this.approvalData });
      // User 데이터 준비
      utils.assign(dataParams.data, { approvalUserList: approvalLineList });

      // 첨부파일 데이터 준비
      const attachFileList = this.$refs.fileAttacher.getAttachFileListInfo();
      if (attachFileList.length > 0) {
        utils.assign(dataParams.data, { attachFileList });
        utils.set(dataParams.data, 'approvalModuleCode', this.approvalModuleCode);
        utils.set(dataParams.data, 'approvalAttachGroupId', this.approvalAttachGroupId);
      }

      http.request(this.contextPageId, 'DTS_CML_00005', dataParams).then(() => {
        // "상신 되었습니다."
        utils.messageBox('success', this.$t('MSG_BTN_CFRM'), this.$t('MSG_TXT_CPLT_SUBM'), () => {
          if (this.isThisWindowPopup) {
            // TODO: 
            window.CLOSE_SILIENTLY = true;
            window.TARGET_PAGEID = 'PGE_CML_00001';
            window.close();
          } else {
            this.closePagePopup(true);
          }
        });
      });
      return true;
    },
    /**
     * approvalUid 로 결재상세 데이터 조회
     */
    getApprovalByApprovalUid() {
      // DTS_CML_00004
      http.request(this.contextPageId, 'DTS_CML_00004', {
        path: {
          'approval-uid': this.pageInitialData.approvalData.approvalUid,
        },
      }).then(res => {
        this.approvalData = res.data;
        this.setApprovalLine(res.data.approvalUserList);
        this.$refs.approvalWebEditor.setHtml(res.data.approvalContent);
      });
    },
    /**
     * 상신의견 팝업 오픈
     * open approval opinion popup
     */
    openApprovalOpinionPopup() {
      return new Promise(resolve => {
        utils.openLayerPopup('PGE_CML_00011', approvalOpinionObj => {
          resolve(approvalOpinionObj);
        }, {
          pageInitialData: {
            approvalTitle: this.approvalData.approvalTitle,
          },
          size: 'md',
        });
      });
    },
    /**
     * 결재선 관리 컴포넌트에 결재선 추가하기
     */
    setApprovalLine(approvalUserList) {
      utils.forEach(approvalUserList, user => {
        utils.set(user, 'approvalDepartmentDispName', this.getDisplayText(user.userDisplayLanguageId, user.approvalDepartmentName, user.approvalDepartmentEnglishName));
        utils.set(user, 'approvalUserCareerLevelDispName', this.getDisplayText(user.userDisplayLanguageId, user.approvalUserCareerLevelName, user.approvalUserCareerLevelEnglishName));
        utils.set(user, 'approvalUserDispName', this.getDisplayText(user.userDisplayLanguageId, user.approvalUserName, user.approvalUserGlobalName));
        utils.set(user, 'userDisplayLanguageId', user.userDisplayLanguageId);
        utils.set(user, 'knoxApprovalOrder', user.approvalParallelOrder);
        utils.set(user, 'approvalType', user.rightApprovalTypeCode);
        if (user.approvalOrder == 0) {
          this.$refs.approvalManager.setDrafter(user);
        } else {
          this.$refs.approvalManager.addApprover(user);
        }
      });
    },
    // 세션 langId 와 displayLangId 를 비교하여 두 개의 값중 하나를 return
    getDisplayText(displayLangId = '', localTextValue = '', globalTextValue = '') {
      return this.$store.getters.userInfo.langId === displayLangId ? localTextValue : globalTextValue;
    },
    // 취소
    onCancel() {
      this.closePagePopup('');
    },
    /**
     * '보류' 버튼 click event handler
     */
    async onClickholdon() {
      this.doHoldon();
      // this.save('holdon');
    },
    /**
     * 상신진행
     */
    onClickProposal() {
      // 상신
      // this.save();
      this.doProposal();
    },
    // 사용자 검색 후 enter event handler
    onSelectedUser(objUser) {
      if (objUser && objUser.userId !== null) {
        this.appendApprover(objUser);
        this.$refs.user.reset();
      }
    },
    /**
     * //
     */
    async setLoginUserToDrafter() {
      const userInfo = utils.clone(this.$store.getters.userInfo);
      userInfo.approvalDepartmentDispName = this.getDisplayText(userInfo.displayLangId, userInfo.departmentName, userInfo.departmentEnglishName);
      userInfo.approvalDepartmentEnglishName = userInfo.departmentEnglishName;
      userInfo.approvalDepartmentId = userInfo.departmentId;
      userInfo.approvalDepartmentName = userInfo.departmentName;
      userInfo.approvalUserCareerLevelCode = userInfo.careerLevelCode;
      userInfo.approvalUserCareerLevelDispName = this.getDisplayText(userInfo.displayLangId, userInfo.careerLevelName, userInfo.careerLevelEnglishName);
      userInfo.approvalUserCareerLevelEnglishName = userInfo.careerLevelEnglishName;
      userInfo.approvalUserCareerLevelName = userInfo.careerLevelName;
      userInfo.approvalUserDispName = this.getDisplayText(userInfo.displayLangId, userInfo.userName, userInfo.userGlobalName);
      userInfo.approvalUserEmail = userInfo.email;
      userInfo.approvalUserGlobalName = userInfo.userGlobalName;
      userInfo.approvalUserId = userInfo.userId;
      userInfo.approvalUserName = userInfo.userName;
      userInfo.userDisplayLanguageId = userInfo.displayLangId;

      const result = await this.validateUserForAppend(userInfo);
      if (result === true) {
        this.$refs.approvalManager.setDrafter(userInfo);
      } else {
        this.closePagePopup();
      }
    },
    /**
     * 상신내용 확인
     * validate approval contents
     */
    validateApprovalContents() {
      return new Promise(resolve => {
        if (this.$refs.approvalWebEditor.getTextSize() === 0 && this.$refs.approvalWebEditor.getImagesInfo().length === 0) {
          // "본문 을(를) 입력해주세요."
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TIT_TBAB')), () => {
            resolve(false);
          });
        } else {
          resolve(true);
        }
      });
    },
    /**
     * validate for approval title
     */
    validateApprovalTitle() {
      return new Promise(resolve => {
        if (utils.isEmpty(this.approvalData.approvalTitle)) {
          // "제목 을(를) 입력해주세요."
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_TITLE')), () => {
            this.$refs.titleTxtFld.setFocus();
            resolve(false);
          });
        } else {
          resolve(true);
        }
      });
    },
    // validate for attached files
    validateAttachFiles() {
      return new Promise(resolve => {
        const attachFileList = this.$refs.fileAttacher.getAttachFileListInfo();
        // 첨부 파일이 존재 할경우만 체크
        if (attachFileList.length > 0 && utils.isEmpty(this.approvalModuleCode)) {
          // "모듈을 확인하세요."
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), utils.strFormat(this.$t('MSG_ALT_CHK_CONFIRM'), this.$t('MSG_TXT_MDLE')), () => {
            resolve(false);
          });
        } else if (this.$refs.fileAttacher.isUnderAttachFileSizeLimit(true) === false) {
        // 첨부파일 용량 사이즈 체크.
          // TODO: 메시지 등록
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), utils.strFormat(this.$t('MSG_ALT_CHK_CONFIRM'), this.$t('MSG_TXT_MDLE')), () => {
            resolve(false);
          });
        } else {
          resolve(true);
        }
      });
    },
    /**
     * 결재선 관리 컴포넌트에 추가하기 위한 property 확인
     */
    validateUserForAppend(userInfoObj) {
      return new Promise(resolve => {
        let errorProp = '';
        utils.forEach(USER_PROPS_FOR_APPEND, prop => {
          if (!Object.prototype.hasOwnProperty.call(userInfoObj, prop) || utils.isEmpty(userInfoObj[prop])) {
            errorProp = prop;
            return false;
          }
          return true;
        });

        if (!utils.isEmpty(errorProp)) {
          // TODO: message 등록
          utils.messageBox('warning', '결재선 정보 확인', `결재선 정보 중 '${errorProp}' 값이 누락되었습니다.`, () => {
            resolve(`결재선 정보 중 '${errorProp}' 값이 누락되었습니다.`);
            // don't use reject: await will throws that reject like a exception and immediately stop the progress
          });
        } else {
          resolve(true);
        }
      });
    },
    /**
     * 결재라인을 DB 에 저장하기 위해 필요한 필드 정보 확인
     */
    validateUserForSave(approvalUser = {}) {
      return new Promise(resolve => {
        let errorColumn = '';
        utils.forEach(USER_COLUMNS_FOR_SAVE, column => {
          if (column.required
            && (!Object.prototype.hasOwnProperty.call(approvalUser, column.columnName)
            || _.isNil(approvalUser[column.columnName]) || utils.trim(approvalUser[column.columnName]) === '')) {
            errorColumn = column.columnName;
            return false;
          }
        });

        if (!utils.isEmpty(errorColumn)) {
          // TODO: 메시지 등록
          utils.messageBox('warning', this.$t('MSG_BTN_CFRM'), `[${errorColumn}] 값이 없습니다.`, () => {
            resolve(false);
          });
        } else {
          resolve(true);
        }
      });
    },
    // TODO: 
    selectTemplate(objTemplate) {
      http.request(this.$options.name, 'DTS_CMZ_00075', {
        path: {
          'template-id': objTemplate.templateId,
          'site-id': objTemplate.siteId,
        },
        data: objTemplate,
      }).then(res => {
        // set WebEditorContents
        if (utils.isEmpty(res.data.sendTmpltCntn) === false) {
          this.setContent(res.data.sendTmpltCntn);
        }
      }).catch(error => {
        console.log(error);
      });
    },
  },
};
</script>
<style scoped>
.comm_scr_wrap .row{background-color:#fff}
.col-xs, .col-xs-1, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6,
.col-xs-7, .col-xs-8, .col-xs-9, .col-xs-10, .col-xs-11, .col-xs-12{border:none}
.comm_scrInput_wrap { width: 80%;}
.comm_scr_wrap div.row:first-child { border-top: 0 !important;}
</style>
